import React, { useContext, useEffect, useState, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { Public_Single_Book, Shared_Single_Book } from '@graphql/queries'
import SideBarPage from '@views/SideBarPage'
import SideBar from '@components/SideBar'
import {
  COLORS,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
  IMAGE_SIZES,
  CONTENT_TYPES,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Loader from '@components/Loader'
import Image from '@components/Image'
import Divider from '@components/Divider'
import SubjectHeader from '@components/SubjectHeader'
import ContentHeader from '@components/ContentHeader'
import { getBookImageUrl } from '@helpers/book'
import { AppContext } from '@state/context'
import { setCurrentSection } from '@state/actions/appActions'

const SingleBook = () => {
  const { id, shareLink } = useParams()
  const [state, dispatch] = useContext(AppContext)
  const { currentSection } = state?.app

  const [book, setBook] = useState(undefined)
  const imageUrl = getBookImageUrl(book)
  const { data, error, isValidating } = useSWR([id ? Public_Single_Book : Shared_Single_Book, id ? id : { shareLink }])

  useEffect(() => {
    if (data && !error) {
      const book = id ? data?.publicBook : data?.sharedBook
      setBook(book)

      dispatch(setCurrentSection(book?.sections?.[0]))
    }
    // if (!isValidating && !error && !data.publicBook) {
    //   window.location.replace('/login')
    // }
  }, [data, error, isValidating])
  const breadcrumb = useMemo(() => (book && {
    label: book?.name,
  }), [book])

  return (
    <SideBarPage>
      <SideBar breadcrumb={breadcrumb}>
        {!data && !error && <Loader  />}
        {error && <p>Något blev fel när boken skulle laddas</p>}

        {data && !error && book && book?.subject && (
          <>
            <Divider size={DIVIDER_SIZE.SMALL} />

            <div className={'flex'}>
              {imageUrl &&
                <div className={'h-20 w-20 mr-4'}>
                  <Image
                    size={IMAGE_SIZES.MEDIUM}
                    imageUrl={imageUrl}
                  />
                </div>
              }
              <div className={'flex flex-col'}>
                <SubjectHeader
                  subject={book.subject}
                  type={CONTENT_TYPES.BOOK}
                />
                <Heading
                  headingLevel={HEADING_TYPE.H2}
                  size={TEXT_SIZES.BASE}
                  color={COLORS.WHITE.TEXT}
                >
                  {data?.book?.name}
                </Heading>
              </div>
            </div>

            <Divider size={DIVIDER_SIZE.SMALL} />
            <Divider
              size={DIVIDER_SIZE.LINE}
              color={COLORS.LIGHT_DARK_GREY.BORDER}
              line
            />
          </>
        )}

        {data && !error && book && (
          <SideBar.SectionList
            subject={book.subject}
            sections={book.sections}
            currentSection={currentSection}
            onClick={(section) => dispatch(setCurrentSection(section))}
          />
        )}
      </SideBar>

      {/* main area */}
      <SideBarPage.Content>
        {!data && !error && <Loader />}
        {error && <Text>Nåt gick fel när vi skulle ladda boken</Text>}

        {data && !error && book && currentSection && currentSection.subject && (
          <>
            <ContentHeader />

            {/* {id === '39' &&
              <div id='readspeaker_button1' className='rs_skip rsbtn rs_preserve'>
                <a
                  rel='nofollow'
                  className='rsbtn_play'
                  accessKey='L'
                  title='Lyssna p&aring; sidans text med ReadSpeaker webReader'
                  href={'https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=3&amp;lang=sv_se&amp;voice=Maja-DNN&amp;readid=readspeaker-content&amp;url=' + encodeURIComponent(window.location.href)}
                >
                  <span className='rsbtn_left rsimg rspart'>
                    <span className='rsbtn_text'>
                      <span>Lyssna</span>
                    </span>
                  </span>
                  <span className='rsbtn_right rsimg rsplay rspart'></span>
                </a>
              </div>
            }
            <div id='readspeaker-content'>
              <SectionRenderer section={currentSection} />
            </div> */}
          </>
        )}
      </SideBarPage.Content>
    </SideBarPage>
  )
}

export default SingleBook
